'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAFETY_ELM327 = exports.SAFETY_ALLOUTPUT = exports.SAFETY_TOYOTA_NOLIMITS = exports.SAFETY_HONDA_BOSCH = exports.SAFETY_TOYOTA = exports.SAFETY_HONDA = exports.SAFETY_NOOUTPUT = undefined;
exports.default = Panda;

var _browser = require('./impl/browser');

var _browser2 = _interopRequireDefault(_browser);

var _panda = require('./panda');

var _panda2 = _interopRequireDefault(_panda);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SAFETY_NOOUTPUT = exports.SAFETY_NOOUTPUT = 0;
var SAFETY_HONDA = exports.SAFETY_HONDA = 1;
var SAFETY_TOYOTA = exports.SAFETY_TOYOTA = 2;
var SAFETY_HONDA_BOSCH = exports.SAFETY_HONDA_BOSCH = 4;
var SAFETY_TOYOTA_NOLIMITS = exports.SAFETY_TOYOTA_NOLIMITS = 0x1336;
var SAFETY_ALLOUTPUT = exports.SAFETY_ALLOUTPUT = 0x1337;
var SAFETY_ELM327 = exports.SAFETY_ELM327 = 0xE327;

function Panda(options) {
  options = options || {};
  var device = new _browser2.default(options, navigator.usb);
  options.device = device;
  return new _panda2.default(options);
}